import Quill from 'quill';
import { FormLinkEmbed as PublicFormLinkEmbed } from '../../ui/v1/controls/editors/quill/public/FormLinkEmbed';
import { ImageAssetEmbed } from '../../ui/v1/controls/editors/quill/ImageAssetEmbed';
import { VideoAssetEmbed as PublicVideoAssetEmbed } from '../../ui/v1/controls/editors/quill/public/VideoAssetEmbed';
import { BlockMessage } from '../../ui/v1/controls/editors/quill/public/BlockMessage';
import { YouTubeAssetEmbed as PublicYouTubeAssetEmbed } from '../../ui/v1/controls/editors/quill/public/YouTubeAssetEmbed';
import { TemplatePlaceholderEmbed } from '../../ui/v1/controls/editors/quill/TemplatePlaceholderEmbed';
import { UrlFormat } from '../../ui/v1/controls/editors/quill/UrlFormat';
import { PrivacyPolicyLink } from 'ui/v1/controls/editors/quill/PrivacyPolicyLink';
import { FormLinkEmbed } from 'ui/v1/controls/editors/quill/FormLinkEmbed';
import { VideoAssetEmbed } from 'ui/v1/controls/editors/quill/VideoAssetEmbed';
import { YouTubeAssetEmbed } from 'ui/v1/controls/editors/quill/YouTubeAssetEmbed';
import { TemplatePlaceholderNotAllowedEmbed } from 'ui/v1/controls/editors/quill/TemplatePlaceholderNotAllowedEmbed';
import { TextHintPlaceholderEmbed } from 'ui/v1/controls/editors/quill/TextHintPlaceholderEmbed';
export var QuillScope;
(function (QuillScope) {
    QuillScope["PUBLIC"] = "public";
    QuillScope["APP"] = "app";
})(QuillScope || (QuillScope = {}));
export function registerQuillBlots(scope) {
    switch (scope) {
        case QuillScope.PUBLIC:
            Quill.register(TemplatePlaceholderEmbed);
            Quill.register(PublicFormLinkEmbed);
            Quill.register(PublicVideoAssetEmbed);
            Quill.register(PublicYouTubeAssetEmbed);
            Quill.register(BlockMessage);
            break;
        case QuillScope.APP:
            Quill.register(FormLinkEmbed);
            Quill.register(VideoAssetEmbed);
            Quill.register(YouTubeAssetEmbed);
            Quill.register(TemplatePlaceholderNotAllowedEmbed);
            Quill.register(TemplatePlaceholderEmbed);
            Quill.register(TextHintPlaceholderEmbed);
            break;
        default: {
            throw new Error("Unknown quill scope (" + scope + ")");
        }
    }
    Quill.register(ImageAssetEmbed);
    Quill.register(UrlFormat);
    Quill.register(PrivacyPolicyLink);
}
var DeltaRenderer = /** @class */ (function () {
    function DeltaRenderer(delta) {
        this.quillContainer = (new DOMParser()).parseFromString('<div></div>', 'text/html').body;
        this.quill = new Quill(this.quillContainer);
        this.delta = delta;
    }
    DeltaRenderer.prototype.injectFirstFormText = function (text) {
        var textToInsert = "\n" + text;
        if (this.delta.ops.findIndex(function (operation) { return operation.insert === textToInsert; }) < 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var index = this.delta.ops.findIndex(function (operation) { return operation.insert && operation.insert.FormLinkEmbed; });
            if (index !== -1) {
                this.delta.ops.splice(index + 1, 0, {
                    insert: { BlockMessage: textToInsert },
                });
            }
        }
        return this;
    };
    DeltaRenderer.prototype.getHtml = function () {
        this.quill.setContents(this.delta);
        return this.quillContainer.querySelector('.ql-editor').innerHTML;
    };
    return DeltaRenderer;
}());
export default DeltaRenderer;
